var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.processing)?_c('div',{staticClass:"d-flex justify-content-center"},[_c('i',{staticClass:"fas fa-spinner fa-spin font-22"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }